import React from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaCalendar } from 'react-icons/fa';
import styled from 'styled-components';
import { useScreenQuery } from 'playup-web-core';
import { IoCloseCircle } from 'react-icons/io5';

import appConfig from '../../appConfig';
import './portal-style.css';

const CustomInput = React.forwardRef<HTMLDivElement, CustomInputProps>(
	({ value, label, showClear, onClear, ...props }, ref) => {
		const { isSmall } = useScreenQuery();

		return (
			<InputContainer isSmallScreen={isSmall} ref={ref} {...props}>
				<span>
					{label} {value}
				</span>{' '}
				{showClear && value ? (
					<IoCloseCircle
						onClick={
							onClear
								? (e) => {
										e.stopPropagation();
										onClear();
								  }
								: undefined
						}
					/>
				) : (
					<FaCalendar />
				)}
			</InputContainer>
		);
	}
);

const PortalDatePicker: React.FC<{ label?: string; showClear?: boolean } & ReactDatePickerProps> = ({
	label,
	showClear = false,
	...props
}) => (
	<ReactDatePicker
		todayButton="Select Today"
		dateFormat={appConfig.regions.language === 'enUS' ? 'MM/d/yyyy' : 'd/MM/yyyy'}
		{...props}
		customInput={
			<CustomInput
				value={props.value}
				label={label}
				showClear={showClear}
				onClear={() => props.onChange(null, undefined)}
			/>
		}
	/>
);

export default PortalDatePicker;

interface CustomInputProps {
	value?: string;
	label?: string;
	className?: string;
	showClear?: boolean;
	onClear?: () => void;
}

const InputContainer = styled.div<{ isSmallScreen: boolean }>(({ isSmallScreen }) => ({
	height: '100%',
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '0 15px',
	color: '#a4a6a8',
	fontSize: isSmallScreen ? '14px' : '18px',
	cursor: 'pointer',
}));
